import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

const withExt = (u) => {
  // Las rutas /api/files/ llevan extensión .webp para que el CDN (Cloudflare)
  // las cachee en el edge; el backend acepta el sufijo como alias.
  if (u.startsWith("/api/files/") && !u.split("?")[0].endsWith(".webp")) return u + ".webp";
  return u;
};

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${withExt(u)}`;
};

export const thumbUrl = (u) => {
  if (!u || u.startsWith("http")) return u;
  if (u.startsWith("/api/files/")) return `${withExt(u)}?thumb=1`;
  const m = u.match(/^\/api\/uploads\/([^/]+\.(?:webp|jpg|jpeg|png))$/i);
  if (!m) return u;
  return `/api/uploads/thumbs/${m[1].replace(/\.(jpg|jpeg|png)$/i, ".webp")}`;
};

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Error inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  return String(d);
};
